import { Box, Drawer, List, ListItem, Typography, useMediaQuery, useTheme } from '@mui/material';
import { business } from 'routes/config';
import SidebarItem from './SidebarItem';
import { MdOutlineChevronLeft } from 'react-icons/md';
import { Link } from 'react-router-dom';
import ProfileIcon from 'assets/icons/ProfileIcon';
// import BillingIcon from 'assets/icons/BillingIcon';
import TeamIcon from 'assets/icons/TeamIcon';
import OperatorIcon from 'assets/icons/OperatorIcon';
import KnowledgeIcon from 'assets/icons/KnowledgeIcon';
import IntegrationIcon from 'assets/icons/IntegrationIcon';
import { useBusiness } from 'providers/context/BusinessProvider';
import WorkflowSideIcon from 'assets/icons/WorkflowSideIcon';
import { useGetCurrentUser } from 'apis/user/hook';
// import { useGetBusinessProfile } from 'apis/business/hook';

interface Props {
  isMenuOpen?: boolean;
  handleClose?: () => void;
}

export default function BusinessSidebar({ isMenuOpen, handleClose }: Props) {
  const theme = useTheme();
  const { data: currentUser } = useGetCurrentUser();
  // const { data: businessData } = useGetBusinessProfile();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { selectedWorkspace } = useBusiness();

  return (
    <Drawer
      variant={isMediumScreen ? 'temporary' : 'permanent'}
      open={isMediumScreen ? isMenuOpen : true}
      onClose={handleClose}
      anchor='left'
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          top: isMediumScreen ? 0 : '65px',
          backgroundColor: theme.palette.background.paper
        }
      }}
      ModalProps={{
        keepMounted: true
      }}
    >
      <List>
        <Link to='/' style={{ textDecoration: 'none' }}>
          <ListItem sx={{ fontSize: '22px' }}>
            <MdOutlineChevronLeft />
            <Typography variant='body2' ml={1}>
              Back
            </Typography>
          </ListItem>
        </Link>
        <SidebarItem to={business.profile} icon={<ProfileIcon />} label='Business Profile' />
        {/* {businessData?.payment_status !== 'billing_disabled' && (
          <SidebarItem to={business.billing} icon={<BillingIcon />} label='Billing' />
        )} */}
        <SidebarItem to={business.team} icon={<TeamIcon />} label='Team' />
        <SidebarItem to={business.operator} icon={<OperatorIcon />} label='Operator' />
        <SidebarItem to={business.KnowledgeBases(selectedWorkspace!)} icon={<KnowledgeIcon />} label='Knowledge Base' />
        <SidebarItem to={business.integration(selectedWorkspace!)} icon={<IntegrationIcon />} label='Integrations' />
        {currentUser?.agency_user && (
          <SidebarItem
            to={business.Workflow(selectedWorkspace!)}
            icon={<WorkflowSideIcon />}
            label={
              <Box>
                <Typography>Workflow</Typography>
                <Typography variant='body2' color='text.secondary' fontSize={12}>
                  Visible to Agency Owner
                </Typography>
              </Box>
            }
          />
        )}
      </List>
    </Drawer>
  );
}
